import actionTypes from '../../actions/bill/actionType';

const defaultBillStats = {
  sum: 0, // 付款合计（未结）
  realtimeBalance: 0, // 实时余额
  deposit: 0, // 押金
  totalConsumption: 0, // 消费合计（未结）
  otaPre: 0, // OTA 预付款
};

const defaultFilterParams = {
  type: -1, // 入账类型（-1: 全部, 1: 付款, 0: 消费）
  status: -1, // 结账状态（-1: 全部, 1: 已结, 0: 未结）
  subjectCode: 'all', // 账务项目（all: 全部）
};

const initialState = {
  paymentSubjects: [], // 付款账务项目list
  consumeSubjects: [], // 消费账务项目list
  subjects: [], // 账务项目list

  billStatsLoading: false,
  billStats: defaultBillStats, // 账单统计信息
  orderBillNo: '', // 账单号
  orderBillStatus: 0, // 预订单结算状态（0： 未结，1：已结）

  billListLoading: false,
  billList: [], // 子账单列表
  filterParams: defaultFilterParams, // 列表条件筛选参数

  selectedBills: [], // 选中的子账单list
  selectedBillIds: [], // 选中的子账单id

  roomsLoading: false,
  rooms: [], // 房间列表
  selectedRoom: {
    roomId: 0, // 选中的房间id，0代表订单总账
    roomNo: '', // 房号
    recNo: '', // 子订单号
    status: -1, // 子订单状态
    priceChannel: '', // 渠道代码
    occType: '', // 入住类型(日租房/钟点房)
    roomTypeId: 0, // 房型id
  },

  settlementNo: '', // 结账单号
  settlementAction: '', // 结账动作表示(收款/退款)
  orderMasterUid: '', // 房主uid
  orderMasterInfo: {
    roomId: 0, // 房主所在的房间id
    roomNo: '', // 房主所在的房号
    recNo: '', // 房主所在的子订单号
  },
  masterInfo: {
    certNo: '', // 证件号
    name: '', // 房主姓名
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.INIT_PAYMENT_SUBJECTS:
      const { paymentSubjects } = payload;
      return {
        ...state,
        paymentSubjects,
      };
    case actionTypes.INIT_CONSUME_SUBJECTS:
      const { consumeSubjects } = payload;
      return {
        ...state,
        consumeSubjects,
      };
    case actionTypes.INIT_BILL_SUBJECTS:
      const { subjects } = payload;
      return {
        ...state,
        subjects,
      };

    case actionTypes.SET_BILL_STATS_LOADING:
      const { billStatsLoading } = payload;
      return {
        ...state,
        billStatsLoading,
      };
    case actionTypes.INIT_BILL_STATS:
      const { billStats } = payload;
      return {
        ...state,
        billStats,
      };
    case actionTypes.RESET_BILL_STATS:
      return {
        ...state,
        billStats: defaultBillStats,
      };
    case actionTypes.SET_ORDER_BILL_NO:
      const { orderBillNo } = payload;
      return {
        ...state,
        orderBillNo,
      };
    case actionTypes.SET_ORDER_BILL_STATUS:
      const { orderBillStatus } = payload;
      return {
        ...state,
        orderBillStatus,
      };

    case actionTypes.SET_BILL_LIST_LOADING:
      const { billListLoading } = payload;
      return {
        ...state,
        billListLoading,
      };
    case actionTypes.INIT_BILL_LIST:
      const { billList } = payload;
      return {
        ...state,
        billList,
      };
    case actionTypes.RESET_BILL_LIST:
      return {
        ...state,
        billList: [],
      };
    case actionTypes.UPDATE_BILL_LIST:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.SET_LIST_FILTER_PARAMS:
      const { filterParams } = payload;
      return {
        ...state,
        filterParams,
      };

    case actionTypes.SET_SELECTED_BILLS:
      const { selectedBills } = payload;
      return {
        ...state,
        selectedBills,
      };
    case actionTypes.SET_SELECTED_BILL_IDS:
      const { selectedBillIds } = payload;
      return {
        ...state,
        selectedBillIds,
      };

    case actionTypes.SET_BILL_ROOMS_LOADING:
      const { roomsLoading } = payload;
      return {
        ...state,
        roomsLoading,
      };
    case actionTypes.INIT_BILL_ROOMS:
      const { rooms } = payload;
      return {
        ...state,
        rooms,
      };
    case actionTypes.RESET_BILL_ROOMS:
      return {
        ...state,
        rooms: [],
      };
    case actionTypes.SET_SELECTED_ROOM:
      const { selectedRoom } = payload;
      return {
        ...state,
        selectedRoom,
      };

    case actionTypes.SET_SETTLEMENT_NO:
      const { settlementNo } = payload;
      return {
        ...state,
        settlementNo,
      };
    case actionTypes.SET_SETTLEMENT_ACTION:
      const { settlementAction } = payload;
      return {
        ...state,
        settlementAction,
      };
    case actionTypes.SET_ORDER_MASTER:
      const { orderMasterUid, orderMasterInfo } = payload;
      return {
        ...state,
        orderMasterUid,
        orderMasterInfo,
      };
    case actionTypes.INIT_MASTER_INFO:
      const { masterInfo } = payload;
      return {
        ...state,
        masterInfo,
      };
    default:
      return state;
  }
};
